let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kHbTG")).then(() => parcelRequire('hSA7G'));